import React, { useEffect, useState, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { formValueSelector, change, destroy, getFormValues } from "redux-form";
import { withTranslation } from "react-i18next";
import cx from "classnames";
import downloadCSV from "actions/downloadCSV";

import permissions, { checkPermissions } from "config/permissions";


import AppealMainContent from "./AppealMainContent";
import Proxy from "components/HOC/ContentTabProxy";
import CustomerPanel from "../Ordering/CustomerPanel";
import Loader from "components/Loader";
import BlockedAppeal from "./BlockedAppeal";

import AppealPrintPopup from "./PrintPopup";
// import AppealActionsPopup from "./AppealActionsPopup";

import Breadcrumbs from "../Ordering/common/Breadcrumbs";

import { setBreadCrumbs, removeTab, setTabName } from 'actions/tabs';
import {
    openAppealLinkModal,
    openObjectsLinkModal,
    openCreateAppealFromFileModal,
} from "actions/ui";

// import tabsParams from "constants/tabsParams";


import {
    clearCustomerState,
    getCustomer,
    getContactPerson,
    clearContactPersonState,
    clearEntireCustomerState,
    clearAllCustomers,
} from "actions/customer";
import { setCurrentTab } from "actions";
import {
    getAppealTypesList,
    getAppealStatusList,
    getAppealPriorityList,
    getAppeal,
    getDynamicFormParams,
    getAppealFeedback,
    lockAppealForm,
    appealFetching,
    getAppealActions,
    getAppealDestinations,
    createNewAppeal,
    setSaveAndCreateNew,
    clearAppealState,
    clearAllAppeals,
    setRequireDynParams,
    setRequiredCustomer,
    unlockAppealForm,
    unlockAppealAndClearSource,
    removeAppealLockSource,
    // unlockAppealAndClearSourceWithoutForm,
    setAppealIdCentralPartLoading,
    setFormForceInitValues,
    repeatAppeal,
    appointAppeal
} from "modules/appeal/actions";

import { updateCreatedAppealName } from "actions/call";
import {
    extractAppealFromState,
    extractCustomerFromState,
    closeAppeal,
    searchTree,
    isOrganization,
    isServiceobjectType,
    TabTypeGetters,
    getCustomerBreadcrumbsActions,
    onCustomerCrumbNewAppealClick,
    // onCustomerCrumbExportExcel,
    getConfigTabs,
    getTabsWithPermissions,
    storedConfigTabs,
} from "helpers";

import { getTabs } from "reducers/tabs";
import { get } from "lodash";

import { toggleCustomerCollapseState } from "reducers/layoutCollapse"
// import { updateCurrentTabUrl } from 'actions/index';

import "./styles.scss";

const CLIENT_TAB_TYPE = 'appealClient';


function Appeal(props) {
    const {
        t,
        appeal,
        appealIsBlocked,
        appealTypes,
        priorityList,
        id,
        fetching,
        match,
        location,
        history,
        incomePhoneNumber,
        currentTab,
        setTabName,
        formValues,
        statusListInitializedType,
        // customerId,
        isDestinationsNeedRefresh,
        destination,
        appealDestination,
        destinations,
        unlockAppealForm,
        // unlockAppeal,
        isLockingAppeal,
        unlockAppealAndClearSource,
        unlockedAppeal,
        appealLockSourceList,
        removeAppealLockSource,
        // unlockAppealAndClearSourceWithoutForm,
        appealLockError,
        savingAppeal,
        loadingParams,
        isRefreshAppealNeeded,
        isUnlockingAppeal,
        isCentralPartLoading,
        setAppealIdCentralPartLoading,
        setFormForceInitValues,
        customer,
        contactPerson,
        customerType,
        customerTypeId,
        // repeatAppeal,
        canGenerateFile,
        breadcrumbs, 
        setBreadCrumbs,
        canCreateRepeatAppeal,
        canCallQuality,
        canEditLinkAppeal,
        beingCreatedAppeal,

        showAppealLinkModal, 
        openAppealLinkModal, 
        showObjectLinkModal, 
        openObjectsLinkModal,

        canCreateAppeal,
        isCreateAppealFromExcel,

        openCreateAppealFromFileModal,
        customerCollapseState,
        toggleCustomerCollapseState,

        appealTabsState,

        // contactPersonAppealsGrid,

        // customerAppealsGrid,

        isHideCustomerPanel,

        match: {
            params: {
                appealId,
                subTabId,
            }
        }
    } = props;

    // const [tabsWidth, setTabsWidth] = useState(localStorage.getItem("appeals_tabsWidth") === null ? DEFAULT_TABS_WIDTH : localStorage.getItem('appeals_tabsWidth')); // should be true by default
    // const [tabsOpened, setTabsOpened] = useState(localStorage.getItem("appeals_tabsOpened") === null ? true : localStorage.getItem('appeals_tabsOpened') === 'true'); // should be true by default

    const [isNewAppealCreating, setIsNewAppealCreating] = useState(false);

    const currentTabId = subTabId || appealId;

    const operators = get(appeal, "openMode.operators", []);

    const isLockedByOperator = operators.some(operator => operator.code === "edit" && !operator.owner);

    const isLockedByOther = isLockedByOperator || appealLockError || isRefreshAppealNeeded;

    // const [isAppealInitialized, setIsAppealInitialized] = useState(false);
    const [isDestInitialized, setIsDestInitialized] = useState(false);
    const [isTabsAvailable, setIsTabsAvailable] = useState(false);

    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const [printPopupIsOpen, setPrintPopupIsOpen] = useState(false);
    const [callQuality, setCallQuality] = useState(false);

    const [duplicateAppealIsBlocked, setDuplicateAppealIsBlocked] = useState(false);
    const [appointAppealIsBlocked, setAppointAppealIsBlocked] = useState(false);

    const actionButtonRef = useRef(null);

    const [isNeededRefresh, setIsNeededRefresh] = useState(false);
    // isAppointedNeedRefresh used to handle case when user appointed an appeal and clicked to its tab - we need to update it to the new latest appointed data
    const [isAppointedNeedRefresh, setIsAppointedNeedRefresh] = useState(false);
    const [needReinitialize, setNeedReinitialize] = useState({}); // set in format id: boolean
    // const [needUpdate, setNeedUpdate] = useState({}); // set in format id: boolean
    // const [isCentralPartLoading, setIsCentralPartLoading] = useState({}); // object in format id: boolean
    // console.log({needReinitialize, needUpdate, isCentralPartLoading});
    const appealTypeId = useMemo(() => formValues && formValues.type && formValues.type.id);
    const appealStatusFromTemplate = useMemo(
        () => formValues && formValues.type && formValues.type.isStatusFromTemplate
    );
    const appealResolutionFromTemplate = useMemo(
        () => formValues && formValues.type && formValues.type.isResolutionFromTemplate
    );

    useEffect(() => {
        // setIsAppealInitialized(false);
        if (!fetching) {
            requestInitialData();
        }
        return () => {
            setIsDestInitialized(false);
        };
    }, [id]);

    useEffect(() => {
        const queryKey = `appeals_${id}`;

        // if (appeal && currentTab.queryKey === queryKey && !currentTab.displayedName) {
        // console.log({displayedName: currentTab && currentTab.displayedName, queryKey, regnum: appeal.regnum})
        if (appeal && currentTab.name === queryKey && !currentTab.displayedName) {
            setTabName(currentTab.name, appeal.regnum);
        }
        // SDSUI-8081 case support when newly appointed appeal tab was not changing its tab name
        if (appeal && currentTab.name === queryKey && appeal.regnum !== currentTab.displayedName) {
            setTabName(currentTab.name, appeal.regnum);
        }
    }, [appeal, currentTab]);

    // refetsh list for <StatusList> component on appeal type change (based on formValues)
    // refetch only if it was initialized and cached type is different from current one
    useEffect(() => {
        if (appealTypeId && statusListInitializedType && appealTypeId !== statusListInitializedType) {
            props.getAppealStatusList(id, appealTypeId, appealStatusFromTemplate, appealResolutionFromTemplate);
        }
    }, [appealTypeId]);

    // to refresh appeal status list once isNeededRefresh is true and both appeal and formValues are ready
    useEffect(() => {
        if (appeal && formValues && isNeededRefresh) {
            props.getAppealStatusList(id, appealTypeId, appealStatusFromTemplate, appealResolutionFromTemplate);
            setIsNeededRefresh(false);
        }
    }, [appeal, formValues, isNeededRefresh]);

    // make init list fetch once appealTypeId is available and no statusListInitializedType is provided yet
    useEffect(() => {
        if (appealTypeId && id && !statusListInitializedType) {
            props.getAppealStatusList(id, appealTypeId, appealStatusFromTemplate, appealResolutionFromTemplate);
        }
    }, [id, appealTypeId]);

    useEffect(() => {
        // if (!isDestInitialized && destinations && destinations.length > 0) {
        if (!isDestInitialized && destinations && Array.isArray(destination)) {
            setIsDestInitialized(true);
        }
    }, [destinations]);

    useEffect(() => {
        if (isDestinationsNeedRefresh) {
            reloadDestinations();
        }
    }, [isDestinationsNeedRefresh]);

    useEffect(() => {
        if (appeal && !isUnlockingAppeal && unlockedAppeal && appealLockSourceList && appealLockSourceList.length === 0) {
            unlockAppealAndClearSource(appeal.id);
        }
    }, [isUnlockingAppeal, unlockedAppeal, appealLockSourceList]);
    


    // all locking processed could be simple handling there via such logic, so other places are only changing "lockSource" list
    useEffect(() => {
        // used to handle again locking appeal, when for example customer was closed by clicking "open comment" or "mailing form"
        // appeal was unlocked during that process, but not locked again
        if (!unlockedAppeal && !isLockingAppeal && appealLockSourceList && appealLockSourceList.length > 0) {
            // console.log("**** LOCK APPEAL FROM APPEAL ****", appealLockSourceList);
            // do not lock appeal in case of only destinations lock source
            if (appealLockSourceList.length === 1 && appealLockSourceList[0] === 'destinations') {
                return;
            }
            // do not lock appeal if it is locked by other (lockError, operator lock, refreshNeeded)
            if (isLockedByOther) {
                return;
            }
            handleLockAppealForm(appealLockSourceList[0]);
        }
    }, [isLockingAppeal, unlockedAppeal, appealLockSourceList]);


    useEffect(() => {
        if (!fetching && !savingAppeal && !loadingParams && isAppointedNeedRefresh) {
            // refresh appeal (first - unlock, afterwards - refresh)
            setIsAppointedNeedRefresh(false);
            unlockAppealAndClearSource(appealId);
            requestInitialData(true);
        }
    }, [savingAppeal, loadingParams, fetching, isAppointedNeedRefresh]);

    function handleNeedReinitialize(appealId, value) {
        setNeedReinitialize(prev => ({...prev, [appealId]: value}));
    }

    // function handleNeedUpdate(appealId, value) {
    //     setNeedUpdate(prev => ({...prev, [appealId]: value}));
    // }

    function handleLockAppealForm(unlockType, onSuccess, onFailure) {
        if (appeal && appeal.id) {
            unlockAppealForm(appeal.id, unlockType, unlockedAppeal, onSuccess, onFailure);
        }
    }

    function handleRemoveAppealLockSource(lockSource) {
        if (appeal && appeal.id) {
            removeAppealLockSource(appeal.id, lockSource);
        }
    }

    async function handleDestinationOpen() {
        if (appeal && !destinations && !isDestInitialized) {
            return reloadDestinations();
        }
    }

    function getDestination(newDestinations, selectedDestinations) {
        const newSelectedDestByValue = []; // to be founded by value
        const newSelectedDestByDefault = []; // to be founded by object.isDefault
        const newRoutesByValue = []; // to be founded by value
        const newRoutesByDefault = []; // to be founded by object.isDefault
        // search by value
        selectedDestinations.forEach(i => {
            const isFoundedByValue = searchTree(newDestinations, "result", item => {
                return parseInt(item.object.id) === parseInt(i);
            });

            const isFoundedByDefault = searchTree(newDestinations, "result", item => {
                return item.object.isDefault;
            });

            if (isFoundedByValue) {
                // newSelectedDest = isFoundedByValue;
                newSelectedDestByValue.push(isFoundedByValue.object.id);
                newRoutesByValue.push(isFoundedByValue.object.id);
                // return;
            }
            // check if there is existing another one isDefault or etc destination
            let isFoundedByDefaultSecond = false;
            if (isFoundedByDefault) {
                isFoundedByDefaultSecond = searchTree(newDestinations, "result", item => {
                    return +isFoundedByDefault.object.id !== +item.object.id && item.object.isDefault;
                });
            }

            // only select new destination in case there is only one founded
            if (isFoundedByDefault && !isFoundedByDefaultSecond) {
                // newSelectedDest = isFoundedByDefault;
                newSelectedDestByDefault.push(isFoundedByDefault.object.id);
                newRoutesByDefault.push(isFoundedByDefault.object.route);
            }
        });
        const newSelectedDest = newSelectedDestByValue.length > 0 ? newSelectedDestByValue : newSelectedDestByDefault;
        const newRoutes = newRoutesByValue.length > 0 ? newRoutesByValue : newRoutesByDefault;
        // console.log({newSelectedDest, newSelectedDestByValue, newSelectedDestByDefault});
        return {
            isDefault: newSelectedDestByValue.length === 0,
            newDest: [...new Set(newSelectedDest)],
            newRoutes: [...new Set(newRoutes)],
        };
    }

    function getNewSelectedDestinationAndRoutes(newDestinations) {
        const formDestination = props.destination || [];
        // check either formDestination if available or appealDestination (saved destination inside of appeal)
        // const destinationsToCheck = formDestination.length > 0 ? formDestination : [appealDestination];
        // const newSelectedDestAndRoutes = getDestination(newDestinations, destinationsToCheck);
        const newSelectedByUser = getDestination(newDestinations, formDestination);
        const newSelectedByAppeal = getDestination(newDestinations, [appealDestination]);

        // selected by user is not default and has some values => return it
        if (!newSelectedByUser.isDefault && newSelectedByUser.newDest.length > 0) {
            // console.log("*** RETURNED BY USER ***");
            return newSelectedByUser;
        }
        // selected by user is default and selected by appeal is empty => return default values;
        if (newSelectedByUser.isDefault && newSelectedByAppeal.newDest.length === 0) {
            // console.log("*** RETURNED BY USER ***");
            return newSelectedByUser;
        }
        // selected by appal is not empty and selcted by user returned only default values => return selected by appeal
        return newSelectedByAppeal;
    }

    function changeFormDestination(id, newDest) {
        const newDestination = newDest.length > 0 ? newDest : [""];
        props.change(id, "destination", newDestination);
        // old logic caused reinitialization of DynamicForm, which triggered the scrollbar position to the top
        // setFormForceInitValues(id, { destination: newDestination });
    }

    // to check what is route?
    function changeFormRoute(id, newRoutes) {
        // console.log({id, newRoutes});
        newRoutes.forEach(route => {
            props.change(id, "route", route);
        });
        // props.change(id, 'route', get(newDest, 'object.route'));
    }

    function updateFormRouteAndDest(destinations, id) {
        const { newDest, newRoutes } = getNewSelectedDestinationAndRoutes(destinations);
        const isSomeInitMissed = destination.some(item => !newDest.includes(item));
        const isSomeAdded = newDest.some(item => !destination.includes(item));
        const isChanged = isSomeInitMissed || isSomeAdded;
        if (isChanged) {
            handleLockAppealForm("form");
        }
        changeFormRoute(id, newRoutes); // to check what is route?
        changeFormDestination(id, newDest);
        // console.log("*** UNLOCK DESTINATIONS ***");
        handleRemoveAppealLockSource("destinations");
    }

    function reloadDestinations() {
        if (!appeal) {
            return;
        }
        console.log(
            'Appeal::reloadDestinations: Either customer or refresh actions received, or "destination" initially opened => refresh destinations.'
        );
        if (appeal.id && appealTypeId) {
            handleLockAppealForm("destinations");
            props.getAppealDestinations(appeal.id, appealTypeId)
            .then(result => {
                updateFormRouteAndDest(result, appeal.id);
            })
            .catch(e => {
                handleRemoveAppealLockSource("destinations");
                console.error("Appeal::refetchDestinations: Error: ", e);
            });
        }
    }

    async function requestInitialData(isRefresh) {
        if (isRefresh) {
            props.destroyForm(`appeal-form-${id}`);
            setIsNeededRefresh(true);
        }

        const appeal = await props.getAppeal({ id }, false, !!incomePhoneNumber);

        if (!appeal) {
            return;
        }

        let appealDataSet = [
            // props.getAppealStatusList(appeal.id, appeal.typeId), // getAppealStatusList is now called within [appealTypeId] useEffect
            // props.getAppealDestinations(appeal.id, appeal.typeCode),
            props.getDynamicFormParams({
                ctxObjectId: appeal.id,
                objectType: "appeal",
                objectTypeId: appeal.typeId,
                objectId: appeal.id,
                objectTypeCode: appeal.typeCode,
                openMode: "create",
            }),
            props.getAppealActions(appeal, [appeal.destinationId], true),
        ];

        if (!priorityList) {
            appealDataSet = [...appealDataSet, props.getAppealPriorityList(id)];
        }

        if (appeal.customerId > 0) {
            appealDataSet = [
                ...appealDataSet,
                // props.getCustomer({ customerId: appeal.customerId }, appeal.customerId),
                props.getAppealFeedback({ appealId: appeal.id, customerId: appeal.customerId }),
            ];

            if (appeal.contactPersonId > 0) {
                appealDataSet = [...appealDataSet];
            }
        }

        const dataSetReady = await Promise.all(appealDataSet);

        // check destinations
        if (dataSetReady) {
            props.appealFetching(id);
        }
    }

    async function postSave({ saveAndCreateNew, appealId }) {
        const saveAndClose = localStorage.getItem("saveAndClose") === "true";
        setAppealIdCentralPartLoading(appealId, true);

        if (saveAndClose) {
            setAppealIdCentralPartLoading(appealId, false);
            closeAppeal({ ...props, id: appealId, lastTab: props.tabs.length === 1 });
            props.removeTab(
                { tabType: props.currentTab.type, history },
                { history, tabs: props.tabs, current: props.currentTab, currentSuperTabPath: props.currentSuperTabPath }
            );
        } 

        if (!saveAndClose || saveAndCreateNew) {
            const updatedAppealData = await props.getAppeal({ id: appealId }, true);
            if (saveAndCreateNew) {
                const appealRequestData = {};
    
                if (updatedAppealData.customerId) {
                    appealRequestData.customerId = updatedAppealData.customerId;
                }
    
                if (updatedAppealData.contactPersonId) {
                    appealRequestData.contactPersonId = updatedAppealData.contactPersonId;
                }
                
                props.createNewAppeal({ appealRequestData }).then(newAppeal => {
                    props.history.push(`/appeals/${newAppeal.id}/`);
                });
            }
            // if saveAndClose then it doesnt make sence to update data for closed appeal
            if (!saveAndClose) {
                await Promise.all([
                    props.setRequireDynParams(appealId, false),
                    props.setRequiredCustomer(appealId, false),
                    props.change(appealId, "destination", [updatedAppealData.destinationId]),
                    props.change(appealId, "resolveDate", updatedAppealData.resolveDate.resolveDate),
                    props.getAppealActions(updatedAppealData, [updatedAppealData.destinationId], true),
                    props.getAppealStatusList(updatedAppealData.id, updatedAppealData.typeId),
                    props.setTabName(`appeals_${updatedAppealData.id}`, updatedAppealData.regnum),
                    props.updateCreatedAppealName({ id: updatedAppealData.id, name: updatedAppealData.regnum }),
                ]);
    
                const res = await props.getDynamicFormParams({
                    ctxObjectId: appealId,
                    objectType: "appeal",
                    objectTypeId: updatedAppealData.typeId,
                    objectId: appealId,
                    objectTypeCode: appeal.typeCode,
                    openMode: "create",
                });
                if (res) {
                    handleNeedReinitialize(appealId, true);
                }
            }
            setAppealIdCentralPartLoading(appealId, false);
        }
    }

    async function resetAppealType(appealType, previousType) {
        // console.log({appealType, previousType});
        const [newDestinations, newFormParams] = await Promise.all([
            // props.getAppealDestinations(appeal.id, appealType.code),
            props.getAppealDestinations(appeal.id, appealType.id),

            props.getDynamicFormParams({
                ctxObjectId: appeal.id,
                objectType: "appeal",
                objectTypeId: appealType.id,
                objectId: appeal.id,
                objectTypeCode: appealType.code,
                prevObjectTypeId: previousType.id,
                openMode: "create",
            }),
        ]);

        handleNeedReinitialize(appeal.id, true);

        updateFormRouteAndDest(newDestinations, appeal.id);

        return [newDestinations, newFormParams];
    }

    function resetActions({ remove, change, position }) {
        const requestDestination = props.destination && Array.isArray(props.destination) ? [...props.destination] : [];

        if (requestDestination[remove]) {
            props.getAppealActions(appeal, requestDestination.splice(remove, 1));
        }

        if (change) {
            requestDestination[position] = change;
            props.getAppealActions(appeal, requestDestination);
        }
    }

    const togglePopup = () => setPopupIsOpen(prev => !prev);

    const closePopup = (e) => {
		const actionButtonClick = actionButtonRef && actionButtonRef.current && actionButtonRef.current.contains(e.target);
		return actionButtonClick ? null : togglePopup();
	};

    const openPrintPopup = () => {
        setPrintPopupIsOpen(true);
        setPopupIsOpen(false);
    };
	
	const closePrintPopup = () => {
        setPrintPopupIsOpen(false);
    };

    const openRepeatAppeal = (trackCallback) => {
		const requestData = {
			repeatRequestId: appeal.id,
			appealId: appeal.id,
			typeCode: 'PRECRM'
		};
		const onSuccess = createdAppeal => {
            history.push(`/appeals/${createdAppeal.id}/`);
            trackCallback(false);
        };
		
		return repeatAppeal(requestData, onSuccess);
	};

    const toggleCodeQuality = () => {
        setCallQuality(prev => !prev);
        setPopupIsOpen(false);
	};

    const excelExport = () => {
		const requestData = { appealId: appeal.id, filter: 0, query: null };
		downloadCSV({
			requestData,
			key: 'appeal_interaction_csv',
		}, togglePopup);
	};

    const updateBreadcrumbs = () => {
		const newBreadcrumbs = [];
		
		if (isOrganization(customerType) || isServiceobjectType(customerType)) {
			newBreadcrumbs.push({

				type: 'customer',
                path: `/appeals/${appeal.id}/customer/${customer.id}`,
				name: customer.party.officialName,
				id: customer.id,
				// subTab: !breadcrumbs ? 'appeals' : breadcrumbs[0] && breadcrumbs[0].subTab
				subTab: 'appeals',
                icon: isOrganization(customerType) ? "customer/organization" : "customer/serviceobject",
			});
			
			contactPerson && newBreadcrumbs.push({
				type: 'contactPerson',
				path: `/appeals/${appeal.id}/person/${contactPerson.id}`,
				name: contactPerson.party.fullName,
				id: contactPerson.id,
				// subTab: !breadcrumbs ? 'appeals' : breadcrumbs[1] && breadcrumbs[1].subTab
				subTab: 'appeals',
                icon: "customer/contactPerson"
			});
		}
		
		if (customerType === 'individual') {
			const fullName = get(customer, 'party.fullName', '').trim();
			newBreadcrumbs.push({
				type: 'customer',
                path:`/appeals/${appeal.id}/customer/${customer.id}`,
				name: fullName,
				id: customer.id,
				// subTab: !breadcrumbs ? 'appeals' : breadcrumbs[0] && breadcrumbs[0].subTab
				subTab: 'appeals',
                icon: "customer/individual"
			});
			contactPerson && newBreadcrumbs.push({
				type: 'contactPerson',
                path: `/appeals/${appeal.id}/person/${contactPerson.id}`,
				name: contactPerson.party.fullName,
				id: contactPerson.id,
				// subTab: !breadcrumbs ? 'contact' : breadcrumbs[1] && breadcrumbs[1].subTab
				subTab: 'appeals',
                icon: "customer/contactPerson"
			});
		}
		
		let appealStatusText = appeal.status.name;
		
		if (appeal.resolution.title) {
			appealStatusText = `${appeal.status.name}: ${appeal.resolution.title}`;
		}
		
		newBreadcrumbs.push({
			type: 'main',
			path: `/appeals/${appeal.id}`,
			name: `${t('tabs.appeals')} ${appeal.regnum}`,
			id: appeal.id,
			statusName: appealStatusText,
            statusClassName: `sticker sticker-${appeal.status.code}`,
			statusCode: appeal.status.code,
			// locked: crumb.lockId !== 0,
			// code: crumb.code,
			subTab: !breadcrumbs ? 'knowledgeBase' : breadcrumbs[breadcrumbs.length - 1] && breadcrumbs[breadcrumbs.length - 1].subTab,
			// subTab: 'knowledgeBase'
            icon: "navigation/appeals"
		});
        setBreadCrumbs(newBreadcrumbs);
	};

    useEffect(() => {
        if (appeal && appeal.id) {
            updateBreadcrumbs();
        }
        if (customer) {
            const tabs = storedConfigTabs(customerType);
            if (!tabs || tabs.length === 0) {
                getConfigTabs({
                    onSuccess: () => setIsTabsAvailable(true),
                    customerType,
                    isBillingView: false,
                    pApartId: customer.externalId,
                    customerId: customer.id,
                });
            }
        }
    }, [appeal, customer, contactPerson]);

    // useEffect(() => {
    //     return () => {
    //         setBreadCrumbs();
    //     };
    // }, [appealId]);

    const wrapHandler = (handler, trackCallback) => (event) => {
        trackCallback(true);
        closePopup(event);
        handler(trackCallback);
    };

    const callLinkModal = (type) => {
        return (event) => {
			closePopup(event);
			if (type === "appeal" && !showAppealLinkModal) {
				openAppealLinkModal();
			};
			if (type === "object" && !showObjectLinkModal) {
				openObjectsLinkModal();
			};
        };
    };

    const onAppointAppeal = (trackCallback) => {
        const requestData = {
            appealId: beingCreatedAppeal.id,
            repeatRequestId: appeal.id,
        };

        const onSuccess = () => {
            const pathname = history.location && history.location.pathname;

            if (pathname.includes(`/appeals/${beingCreatedAppeal.id}/`)) {
                // user clicked on appeal tab which should be appointed => refresh appeal
                setIsAppointedNeedRefresh(true);
            } else {
                history.push(`/appeals/${beingCreatedAppeal.id}/`);
            }
            trackCallback(false);
        }

        closeAppeal({ ...props, id: beingCreatedAppeal.id, lastTab: props.tabs.length === 1 });
        removeTab({
            tabType: TabTypeGetters.appeal(beingCreatedAppeal.id),
            history
        });
        return appointAppeal(requestData, onSuccess);
    };

    const isNewAppeal = appeal && appeal.statusAss === 'beingCreated';

    const canCreateRepeatedAppealFromSource =
            !isNewAppeal &&
            beingCreatedAppeal &&
            Number(appealId) !== Number(beingCreatedAppeal.id);

    // console.log({
    //     isNewAppeal,
    //     beingCreatedAppeal,
    //     appealId,
    //     canCreateRepeatedAppealFromSource,
    //     canCreateRepeatAppeal,
    //     isBeingCreated: get(beingCreatedAppeal, "status.code") === "beingCreated",
    //     customer: get(appeal, "customerId"),
    // });

    // const onNewAppealClick = async isContactPerson => {
    //     setIsNewAppealCreating(true);

    //     const newCustomerId = customer && customer.id || get(contactPerson, 'links[0].entityId');

    //     const appealRequestData = {
    //         customerId: newCustomerId,
    //         // contactPersonId: contactPerson.id,
    //     };
        
    //     if (isContactPerson) {
    //         appealRequestData.contactPersonId = contactPerson && contactPerson.id;
    //     }

    //     try {
    //         const createdAppeal = await props.createNewAppeal({ appealRequestData });
    //         setIsNewAppealCreating(false);
    //         if (createdAppeal) {
    //             history.push(`/appeals/${createdAppeal.id}/`);
    //         }
    //     } catch (e) {
    //         setIsNewAppealCreating(false);
    //         console.error("Appeal::onNewAppealClick: Error ", e);
    //     }
    // };

    // const exportExcel = (isContactPerson) => {
    //     const appealFields = Object.entries(tabsParams(t).filter).reduce((acc, [key, value]) => {
    //         const nameParts = [key];
    //         if (value.objectField) nameParts.push(value.objectField);

    //         acc[nameParts.join(".")] = value.name;

    //         return acc;
    //     }, {});

    //     const requestData = {
    //         fields: appealFields,
    //         customerId: customer && customer.id,
    //         // contactPersonId: contactPerson && contactPerson.id,
    //         start: null,
    //         limit: null,
    //     };

    //     if (isContactPerson) {
    //         requestData.contactPersonId = contactPerson && contactPerson.id;
    //     }

    //     const grid = isContactPerson ? contactPersonAppealsGrid : customerAppealsGrid;
    //     const gridSort = get(grid, "params.sort");

    //     if (gridSort.field && gridSort.order) {
    //         requestData["sort"] = [
    //             {
    //                 property: gridSort.field,
    //                 direction: gridSort.order.toUpperCase(),
    //             },
    //         ];
    //     }

    //     // if (this.props.gridSort.field && this.props.gridSort.order) {
    //     //     requestData['sort'] = [
    //     //         {
    //     //             property: this.props.gridSort.field,
    //     //             direction: this.props.gridSort.order.toUpperCase(),
    //     //         },
    //     //     ];
    //     // }

    //     downloadCSV({ requestData, key: "appeal_customer_csv" });
    // };

    const customerActions = getCustomerBreadcrumbsActions({
        t,
        customerType,
        customerTypeId,
        customer,
        isNewAppealCreating,
        history,
        setIsNewAppealCreating,

        // contactPerson,
        // contactPersonAppealsGrid,
        // customerAppealsGrid,
    });

    // const customerActions = [

    //     ...customerPrimaryActions,
    //     {
    //         name: t("filters.exportExcelAppeals"),
    //         handler: () => exportExcel(false),
    //         show: true,
    //         disabled: !customerAppealsGrid,
    //         primary: false,
    //     },
    //     {
    //         name: t("createAppealFromFile"),
    //         handler: () => openCreateAppealFromFileModal({
    //             customerId: customer && customer.id,
    //             // contactPersonId: contactPerson && contactPerson.id,
    //         }),
    //         show: isCreateAppealFromExcel,
    //     }
    // ];

    const contactPersonActions = [
        {
            name: t("newEntityButton.appeals"),
            handler: () =>
                onCustomerCrumbNewAppealClick({
                    isContactPerson: true,
                    customer,
                    contactPerson,
                    history,
                    setIsNewAppealCreating,
                }),
            show: canCreateAppeal,
            disabled: isNewAppealCreating,
            primary: true,
        },
        // {
        //     name: t("filters.exportExcelAppeals"),
        //     handler: () =>
        //         onCustomerCrumbExportExcel({
        //             isContactPerson: true,
        //             t,
        //             customer,
        //             contactPerson,
        //             contactPersonAppealsGrid,
        //             customerAppealsGrid,
        //         }),
        //     show: true,
        //     disabled: !contactPersonAppealsGrid,
        //     primary: false,
        // },
        {
            name: t("createAppealFromFile"),
            handler: () => openCreateAppealFromFileModal({
                customerId: customer && customer.id,
                contactPersonId: contactPerson && contactPerson.id,
            }),
            show: isCreateAppealFromExcel,
        }
    ];

    const appealActions = [
        { name: t("appeal.printPattern"), handler: openPrintPopup, show: canGenerateFile, primary: true },
        {
            name: t("appeal.secondAppeal"),
            handler: wrapHandler(openRepeatAppeal, setDuplicateAppealIsBlocked),
            show: !isNewAppeal && canCreateRepeatAppeal && get(appeal, 'customerId'),
            disabled: duplicateAppealIsBlocked,
            primary: true,
        },
        {
            name: t('appeal.secondAppealFromSource') + get(beingCreatedAppeal, 'regnum'),
            handler: wrapHandler(onAppointAppeal, setAppointAppealIsBlocked),
            show: 
                canCreateRepeatedAppealFromSource &&
                canCreateRepeatAppeal &&
                get(beingCreatedAppeal, "status.code") === "beingCreated" &&
                get(appeal,'customerId'),
            disabled: appointAppealIsBlocked,
            primary: true,
        },
        {
            name: t("filters.exportExcelHistory"),
            handler: excelExport,
            show: true,
            primary: true,
        },

        {
            name: t("appealForm.linkAppeal"),
            handler: callLinkModal("appeal"),
            show: canEditLinkAppeal,
            primary: true,
        },

        {
            name: t("appealForm.linkObject"),
            handler: callLinkModal("object"),
            show: canEditLinkAppeal && customer,
            primary: true,
        },

        {
            name: t("quality.Title"),
            handler: toggleCodeQuality,
            show: canCallQuality,
            primary: true,
        },
    ];

    if (appealIsBlocked) {
        return <BlockedAppeal />;
    }

    if (!props.fetching || !appeal) {
        return (
            <div className="wrapper">
                <Loader withContainer />
            </div>
        );
    }

    return (
        <div className="appeal-wrapper">
            {savingAppeal && <Loader />}
            <Breadcrumbs
                // className={cx("appeals-breadcrumbs", {'without-tabs': !tabsOpened, [tabsWidth]: tabsWidth})}
                className={cx("appeals-breadcrumbs", {
                    "without-tabs": appealTabsState === "layout-collapse-collapsed",
                    [appealTabsState]: appealTabsState,
                })}
                currentId={currentTabId}
                breadcrumbs={breadcrumbs}
                setBreadCrumbs={setBreadCrumbs}
                customerActions={customerActions}
                contactPersonActions={contactPersonActions}
                mainActions={appealActions}
                collapseState={customerCollapseState}
                // onCollapseClick={() => toggleCustomerCollapseState(CLIENT_TAB_TYPE)}
                onCollapseClick={!isHideCustomerPanel && (() => toggleCustomerCollapseState(CLIENT_TAB_TYPE))}
            />
            {
                printPopupIsOpen &&
                <AppealPrintPopup
                    onClose={closePrintPopup}
                    typeId={appeal.typeId}
                    appealId={appeal.id}
                />
            }
            <div className="appeal-main-wrapper">
                <CustomerPanel
                    onAppealDestinationsReload={reloadDestinations}
                    unlockAppealForm={handleLockAppealForm}
                    removeAppealLockSource={handleRemoveAppealLockSource}
                    isLockedByOther={isLockedByOther}
                    isLockingAppeal={isLockingAppeal}
                    clientTabType={CLIENT_TAB_TYPE}
                />
                <AppealMainContent
                    resetAppealType={resetAppealType}
                    needReinitialize={needReinitialize[id]}
                    setNeedReinitialize={handleNeedReinitialize}
                    requestInitialData={requestInitialData}
                    resetActions={resetActions}
                    postSave={postSave}
                    onDestinationOpen={handleDestinationOpen}
                    unlockAppealForm={handleLockAppealForm}
                    removeAppealLockSource={handleRemoveAppealLockSource}
                    unlockAppealAndClearSource={unlockAppealAndClearSource}
                    operators={operators}
                    isLockedByOther={isLockedByOther}
                    lockSourceList={appealLockSourceList}
                    lockError={appealLockError}
                    savingAppeal={savingAppeal}
                    isCentralPartLoading={isCentralPartLoading}
                    // isCentralPartLoading={isCentralPartLoading[id]}
                    loadingParams={loadingParams}
                    unlockedAppeal={unlockedAppeal}
                    callQuality={callQuality}
                    toggleCodeQuality={toggleCodeQuality}
                    // setTabsWidth={setTabsWidth}
                    // setTabsOpened={setTabsOpened}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state, props) {
    const [appeal, id] = extractAppealFromState(state, props);
    const customer = extractCustomerFromState(state, get(appeal, "currentAppeal.customerId"));

    const contactPerson = get(customer, 'currentContactPerson');

    const canCreateRepeatAppeal = checkPermissions(
        permissions.AppealOperations.action_createAppealRepeat,
    );

    let beingCreatedAppeal = {};

    if (canCreateRepeatAppeal) {
        beingCreatedAppeal = Object.keys(state.appeal.appeals)
            .map((k) => state.appeal.appeals[k])
            .filter((k) => get(k, 'currentAppeal.statusAss') === 'beingCreated')
            .sort(
                (appealA, appealB) =>
                    get(appealB, 'currentAppeal.validFrom') -
                    get(appealA, 'currentAppeal.validFrom'),
            );
    }

    // person_appeals_156548_6640548.31152
    // const customerId = customer && customer.currentCustomer && customer.currentCustomer.id;
    // const appealId =  appeal && appeal.currentAppeal && appeal.currentAppeal.id;
    // const contactPersonAppealsGridKey = `person_appeals_${appealId}_${customerId}.${contactPerson && contactPerson.id}`;

    // customer_appeals_appeals_appeals_156548.6640548
    // const customerAppealsGridKey = `customer_appeals_appeals_appeals_${appealId}.${customerId}`;

    const appealRestriction = get(appeal, 'currentAppeal.restriction');

    return {
        id,
        statusListInitializedType: appeal.statusListInitializedType,
        destinations: appeal.destinations,
        appeal: appeal.currentAppeal,
        isLockingAppeal: appeal.unlockAppeal,
        isUnlockingAppeal: appeal.isUnlocking,
        unlockedAppeal: appeal.unlockedAppeal,
        appealLockSourceList: appeal.lockSourceList,
        appealLockError: appeal.lockError,
        appeals: state.appeal.appeals,
        saveAndCreateNew: appeal.saveAndCreateNew,
        fetching: appeal.fetching,
        appealLoading: appeal.appealLoading,
        appealIsBlocked: appeal.appealIsBlocked,
        appealTypes: state.appeal.appealTypes,
        isRefreshAppealNeeded: appeal.isRefreshAppealNeeded,
        priorityList: state.appeal.priorityList,

        savingAppeal: appeal.savingAppeal,
        isCentralPartLoading: appeal.isCentralPartLoading,
        loadingParams: appeal.loadingParams,

        destination: formValueSelector(`appeal-form-${id}`)(state, "destination"),
        appealDestination: get(appeal, "currentAppeal.destinationId"),
        route: formValueSelector(`appeal-form-${id}`)(state, "route.key"),

        formValues: getFormValues(`appeal-form-${id}`)(state),

        forms: state.form,

        tabs: getTabs(state),
        currentTab: state.tabs.current,

        customer: customer.currentCustomer,
        contactPerson,
        customerType: get(customer, 'currentCustomer.party.partyType'),
        customerTypeId: get(customer, 'currentCustomer.party.id'),
        // customerId: get(customer, 'currentCustomer.id'),
        // customerId: get(appeal, 'currentAppeal.customerId'),
        isDestinationsNeedRefresh: get(appeal, "isDestinationsNeedRefresh"),

        isCustomerLoading: customer.customerLoading,

        incomePhoneNumber: state.call.incomePhoneNumber,
        currentSuperTabPath: state.tabs.currentSuperTabPath,

        canGenerateFile: checkPermissions(permissions.FileOperations.generate_file),
        canCallQuality: checkPermissions(permissions.InteractionOperations.action_AddAssessments),
        canEditLinkAppeal: checkPermissions(permissions.LinkOperations.actionEditLinks),
        breadcrumbs: state.tabs && state.tabs.current && state.tabs.current.breadcrumbs,
        canCreateRepeatAppeal,
        beingCreatedAppeal: get(beingCreatedAppeal, '[0].currentAppeal'),
        showAppealLinkModal: state.ui.showAppealLinkModal,
		showObjectLinkModal: state.ui.showObjectLinkModal,


        canCreateAppeal: checkPermissions(permissions.AppealOperations.action_createAppeal),
        isCreateAppealFromExcel: checkPermissions(permissions.AppealOperations.action_createAppealGroupFromClient),


        customerCollapseState: get(state, `layoutCollapse.${CLIENT_TAB_TYPE}.collapseState`),

        appealTabsState: get(state, `layoutCollapse.appeal.collapseState`),

        // contactPersonAppealsGrid: get(state.grid, contactPersonAppealsGridKey),
        // customerAppealsGrid: get(state.grid, customerAppealsGridKey),

        isHideCustomerPanel: appealRestriction && appealRestriction.customerId === 0,

    };
}

const mapDispatchToProps = {
    getAppeal,
    getAppealTypesList,
    lockAppealForm,
    getAppealStatusList,
    getAppealPriorityList,
    appealFetching,
    getAppealFeedback,
    getDynamicFormParams,
    getAppealDestinations,
    getAppealActions,
    createNewAppeal,
    setSaveAndCreateNew,
    clearAppealState,
    clearAllAppeals,
    setRequireDynParams,
    setRequiredCustomer,

    getCustomer,
    clearCustomerState,
    getContactPerson,
    clearContactPersonState,
    clearEntireCustomerState,
    clearAllCustomers,

    setTabName,
    setCurrentTab,
    removeTab,

    updateCreatedAppealName,

    // updateCurrentTabUrl,

    unlockAppealForm,
    unlockAppealAndClearSource,
    removeAppealLockSource,
    // unlockAppealAndClearSourceWithoutForm,
    setAppealIdCentralPartLoading,
    setFormForceInitValues,
    // unlockAppeal,

    change: (id, field, value) => change(`appeal-form-${id}`, field, value),
    destroyForm: form => destroy(form),

    // repeatAppeal,
    setBreadCrumbs,
    
    openAppealLinkModal,
	openObjectsLinkModal,
    openCreateAppealFromFileModal,

    toggleCustomerCollapseState,

};

// export default connect(mapStateToProps, mapDispatchToProps)(Appeal);

export default withTranslation()(Proxy(connect(mapStateToProps, mapDispatchToProps)(Appeal), {
    noRequest: true,
    tabType: data => data && `appeals_${data.appealId}`,
    name: data => data && `appeals_${data.appealId}`,
    queryKey: data => data && `appeals_${data.appealId}`,
    storeName: () => "appeals",
}));

// export default Proxy(TabContent, {
// 	noRequest: true,
// 	tabType: data => data && `appeals_${data.appealId}`,
// 	name: data => data && `appeals_${data.appealId}`,
// 	queryKey: data => data && `appeals_${data.appealId}_${data.tab}`,
// 	storeName: data => data && data.tab
// });
